/** Flat one-time price for a 30-day self-serve sponsored placement. */
export const AD_SLOT_PRICE_USD = 99;
export const AD_SLOT_STRIPE_TAX_CODE = "txcd_20060002";
/** How long a RESERVED row is held before a later checkout sweeps it away. */
export const AD_SLOT_RESERVATION_TTL_MS = 30 * 60 * 1000;

/**
 * Ad lifecycle status codes. Kept in this dependency-free module (rather than
 * `ad-checkout.ts`) so client code can import it without dragging the admin
 * InstantDB/Stripe clients into the browser bundle.
 */
export const AD_STATUS = {
	AVAILABLE: 0,
	ACTIVE: 1,
	EXPIRED: -1,
	DELETED: -9,
	RESERVED: 9,
} as const;
